import { cn } from 'src/lib/utils';

interface BetaChartCardProps {
  title: string;
  subtitle?: string;
  controls?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export function BetaChartCard({
  title,
  subtitle,
  controls,
  children,
  className,
}: BetaChartCardProps) {
  return (
    <div
      className={cn(
        'mb-4 overflow-hidden rounded-xl border border-[#EDEEF2] bg-white',
        className,
      )}
    >
      <div className="flex flex-wrap items-start justify-between gap-3 border-b border-[#EDEEF2] px-5 py-4">
        <div>
          <div className="text-sm font-bold tracking-[-0.2px] text-[#0D0F1A]">{title}</div>
          {subtitle ? (
            <div className="mt-0.5 text-xs text-[#9CA3AF]">{subtitle}</div>
          ) : null}
        </div>
        {controls ? <div className="flex flex-wrap items-center gap-2">{controls}</div> : null}
      </div>
      <div className="p-5">{children}</div>
    </div>
  );
}

export function BetaSectionHeading({ children }: { children: React.ReactNode }) {
  return (
    <div className="mb-3.5 flex items-center justify-between">
      <span className="text-[11px] font-bold uppercase tracking-[0.8px] text-[#9CA3AF]">
        {children}
      </span>
    </div>
  );
}
